import React from 'react';
import TranslatedText from './TranslatedText';
import scrollIcon from '../assets/icon-arrow.svg';
import './ScrollIcon.css';

export const ScrollIcon = props => (
    <div className="ScrollIcon">
        <div className="ScrollIcon-icon">
            <img src={scrollIcon} alt="" />
        </div>
        <span>
            <TranslatedText tag={props.tag} />
        </span>
    </div>
);

export default ScrollIcon;



// WEBPACK FOOTER //
// ./src/atoms/ScrollIcon.js